import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    authenticationInProgress: false,
    authenticationError: false,
    formErrorText: '',

    user: JSON.parse(sessionStorage.getItem('user')),
    authProviderConfig: null,

    mfaRequired: false,
    pendingCredentials: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        checkAuthStatus() {},
        loginStart(state) {
            state.authenticationInProgress = true;
            state.authenticationError = false;
            state.formErrorText = '';
        },
        loginCheckMfaStart(state) {
            state.authenticationInProgress = true;
            state.authenticationError = false;
            state.formErrorText = '';
        },
        loginSuccess(state) {
            state.authenticationInProgress = false;
            state.mfaRequired = false;
            state.pendingCredentials = null;
        },
        loginCheckMfaSuccess(state) {
            state.authenticationInProgress = false;
        },
        loginError(state, { payload: error }) {
            state.authenticationInProgress = false;
            state.authenticationError = true;
            state.error = error;
        },
        setMfaRequired(state, { payload }) {
            state.mfaRequired = payload;
        },
        setPendingCredentials(state, { payload }) {
            state.pendingCredentials = payload;
        },
        verifyOtpStart(state) {
            state.authenticationInProgress = true;
            state.authenticationError = false;
            state.formErrorText = '';
        },
        resendOtpStart(state) {},
        setUser(state, { payload: user }) {
            state.user = user;
            state.authenticationInProgress = false;
        },
        logoutStart() {},
        setFormErrorText(state, { payload: errorText }) {
            state.formErrorText = errorText;
        },
        changePasswordStart({ payload }) {},
        changeUserPasswordStart({ payload }) {},
        getUserData(state) {
            state.authenticationInProgress = true;
        },
        getUserDataError(state) {
            state.authenticationInProgress = false;
        },
        ssoLoginSuccess() {},
        getAuthProviderConfig() {
            /* empty */
        },
        setAuthProviderConfig(state, { payload: config }) {
            state.authProviderConfig = config;
        },
    },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
